import { decode } from 'geobuf';
import PBF from 'pbf';
import { BASE_API_URL } from '../envs.js';
import { authFetch, failNotOK, HttpError } from './api-helper.js';
import { createRouteSegmentGpxURL } from '../urlHandling/urlCreate.js';
export function hasClosedWay(detours) {
    return !!detours?.some((d) => d.type === 'closed_way');
}
export async function fetchSegments(land, category, options = {}) {
    const service = options.limit ? '/api/4/segments_limited' : '/api/4/segments';
    const response = await fetch(`${BASE_API_URL}${service}/${land}/${category}`);
    return response.json();
}
export async function fetchRoutes(land, category, lang, options = {}) {
    const service = options.limit ? '/api/4/routes_limited' : '/api/4/routes';
    const response = await fetch(`${BASE_API_URL}${service}/${land}/${category}?lang=${lang}`);
    return response.json();
}
export async function fetchRouteOrSegment(land, routeNumber, segmentNumber, lang) {
    const response = await fetch(`${BASE_API_URL}/api/4/route_or_segment/${land}/${routeNumber}/${segmentNumber}?lang=${lang}`);
    if (response.ok) {
        return response.json();
    }
    else {
        throw new HttpError(response.status, response.statusText);
    }
}
export async function fetchRouteOrSegmentFeature(land, routeNumber, segmentNumber) {
    const response = await fetch(`${BASE_API_URL}/api/4/route_or_segment/${land}/${routeNumber}/${segmentNumber}.geobuf`);
    const data = await response.arrayBuffer();
    const featureCollection = decode(new PBF(data));
    if (featureCollection.features.length !== 1) {
        throw new Error('Invalid features length in geobuf');
    }
    else {
        return featureCollection.features[0];
    }
}
export async function fetchRouteOrSegmentGeometryJSON(routeNumber, segmentNumber, land) {
    const response = await fetch(`${BASE_API_URL}/api/4/route_or_segment/${land}/${routeNumber}/${segmentNumber}.json?srid=2056`);
    if (response.ok) {
        return response.json();
    }
    return undefined;
}
export async function fetchRouteSegmentNumber(segmentWebdbId) {
    const response = await fetch(`${BASE_API_URL}/api/4/route_segment_number/${segmentWebdbId}`);
    if (response.ok) {
        return response.json();
    }
    return undefined;
}
export async function exportRouteSegmentGps(langCode, land, routeNumber, segmentNumber) {
    const url = createRouteSegmentGpxURL(langCode, land, routeNumber, segmentNumber);
    const response = await failNotOK(authFetch(url, false));
    return response.blob();
}
//# sourceMappingURL=api-segments.js.map